var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouth5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60.8 27.2",
    style: {
      enableBackground: "new 0 0 60.8 27.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;fill:#D177B8;}\n\t.st1{fill:#FF6563;}\n\t.st2{fill:#DC3F57;}\n\t.st3{fill:#842751;}\n\t.st4{fill:#DD6B7C;}\n\t.st5{fill:#FFFCB8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,13.4c0,0,7.3,13.8,20.3,13.8c13,0,21-14.4,21-14.4S25.4,23.4,9.7,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.3,4.4c0,0,7.2,19.4,25.9,19.4c18.7,0,25.6-19.4,25.6-19.4s-8.3,5.2-25.6,4.5C12.8,8.2,4.3,4.4,4.3,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.8,6.1c0,0-0.8,0.6-3.9,1.2c-1.9,0.4-4.7,0.8-8.6,1C29.7,9.1,29.5,9.8,29.5,9.8s-8.1-1.5-13.9-1.5 c-2.2,0-4.1-0.4-5.8-1C7.4,6.4,5.7,5.2,5.5,5c0.2,0.1,2.7,1,5,0.6c2.4-0.5,8-5.2,19.7-5.2C41.9,0.4,46.4,6.1,52.8,6.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3,3.1C2.8,2.8,2.6,2.6,2.4,2.4C2.4,2.4,2.6,2.7,3,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58,2.4c-0.2,0.2-0.4,0.4-0.6,0.6C57.7,2.7,58,2.4,58,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,9.4C26.6,7.1,14.2,7.9,9.9,6.8C6.4,6,4,4.1,3,3.1c3,3.2,5,4.7,13,5.3c8.4,0.6,14.2,2.3,14.2,2.4v0l0,0 c0,0,0,0,0,0v0c0.1,0,5.8-1.8,14.2-2.4c8-0.6,10-2.1,13-5.3c-1,1-3.4,3-6.9,3.8C46.1,7.9,33.8,7.1,30.2,9.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.8,6.1c0,0-0.8,0.6-3.9,1.2l-1.2-0.1c0,0-7.8-6.6-18.5-6.4C19.3,1,11,6.5,9.9,7.3C7.4,6.4,5.7,5.2,5.5,5 c0.2,0.1,2.7,1,5,0.6c2.4-0.5,8-5.2,19.7-5.2C41.9,0.4,46.4,6.1,52.8,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.4,0.8c0,0,3.2,1.1,5.4,4.5c0,0,0.3-2.9-1.2-4.6C58-1,55.4,0.8,55.4,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.4,0.8c0,0-3.2,1.1-5.4,4.5c0,0-0.3-2.9,1.2-4.6C2.8-1,5.4,0.8,5.4,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M37,12.6c0,0,3.1,2.5,3.9,4.9l2.9-1.9c0,0-1.2-2.1-3.4-4.2L37,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.5,11c0,0,1.9,2,2.9,4.2l0.5-0.8c0,0-0.5-1.8-2.3-3.8L41.5,11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth5);
export default __webpack_public_path__ + "static/media/Mouth5.a06409a7e07180dc9aa8b2205689691b.svg";
export { ForwardRef as ReactComponent };